import { getTranslation } from '@/hooks/useTranslation';

const title = getTranslation('nav.routes.prompts.title') || 'Prompt Library';

const PromptsRouteNavigationOptions = {
  title,
  headerTitle: title,
  headerBackVisible: false,
};

export default PromptsRouteNavigationOptions;
